import { CalendarClock } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { FamilyReenrollmentPage } from '@/pages/promotion/FamilyReenrollmentPage'
import { NextYearPage } from '@/pages/promotion/NextYearPage'
import type { AppModule } from '../moduleRegistry'

/** Next year: placements planned now, applied when the next year starts; family re-enrolment. */
export const module: AppModule = {
  id: 'promotion',
  routes: {
    admin: [
      {
        path: 'students/next-year',
        element: (
          <RequirePermission permission="students.view">
            <NextYearPage />
          </RequirePermission>
        ),
      },
    ],
    family: [{ path: 'reenrollment', element: <FamilyReenrollmentPage /> }],
  },
  nav: {
    family: [
      {
        order: 15,
        item: {
          label: 'Re-enrolment',
          to: '/portal/reenrollment',
          icon: CalendarClock,
          keywords: 'reenrollment re-enrolment next year class série',
        },
      },
    ],
  },
}
